import { render, staticRenderFns } from "./serviceBox.vue?vue&type=template&id=1a32bb44"
import script from "./serviceBox.vue?vue&type=script&lang=js"
export * from "./serviceBox.vue?vue&type=script&lang=js"
import style0 from "./serviceBox.vue?vue&type=style&index=0&id=1a32bb44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports